import { ChangeEvent, FC } from 'react'

import {
  Button,
  Form,
  Grid,
  Input,
  Picker,
  Row,
  Select,
  SelectForm,
  Span
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import moment from 'moment'
import { ParamFaleConoscoResponseDto } from 'services/NGT/Parameterization'
import { ITalkToUsRequestDto } from 'services/NGT/TalkToUs'
import { SPACING } from 'utils'
import { UseFormWatch } from 'react-hook-form'
import { ITalkToUsProps } from '../..'

interface IFilterTalkToUsProps {
  control: any
  // searchParams: ITalkToUsRequestDto
  handleOnSearch: () => void
  areDatesValid: () => boolean
  handleOnClear: () => void
  errors: any
  parametrizationTalkToUs: ParamFaleConoscoResponseDto[]
  handleSubmit: any
  watch: UseFormWatch<ITalkToUsProps>
  // handleOnChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const FilterTalkToUs: FC<IFilterTalkToUsProps> = ({
  control,
  handleOnClear,
  handleOnSearch,
  handleSubmit,
  // handleOnChange,
  areDatesValid,
  parametrizationTalkToUs,
  errors,
  watch
  // searchParams
}) => {
  return (
    <Form
      onSubmit={handleSubmit(handleOnSearch)}
    >
      <Grid
        gridCols="1fr 1.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <SelectForm
          control={control}
          label="Motivo"
          formValue="idMotivo"
          clearSelect
          // value={searchParams.idMotivo}
          // onChange={handleOnChange}
          key="idParamFaleConosco"
          labelMenu="dsMotivo"
          valueMenu="idParamFaleConosco"
          listOptions={parametrizationTalkToUs}
        />
      </Grid>
      <Grid
        gridCols="1.5fr 0.1fr 1.5fr 1.5fr 5fr 1.5fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Picker
          // maxDate={moment(searchParams.dtEnvioFim) || ''}
          // value={searchParams.dtEnvioInicio}
          control={control}
          formValue="dtEnvioInicio"
          errors={errors}
          // onChange={(date) =>
          //   handleOnChange({
          //     target: { name: 'dtEnvioInicio', value: date }
          //   } as ChangeEvent<HTMLInputElement>)
          // }
          label="Data de"
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          // minDate={moment(searchParams.dtEnvioInicio) || ''}
          // value={searchParams.dtEnvioFim}
          control={control}
          formValue="dtEnvioFim"
          errors={errors}
          // onChange={(date) =>
          //   handleOnChange({
          //     target: { name: 'dtEnvioFim', value: date }
          //   } as ChangeEvent<HTMLInputElement>)
          // }
          label="Data até"
        />
        <Input
          label="Usuário"
          formValue="nmUsuario"
          // value={searchParams.nmUsuario}
          control={control}
          placeholder="Usuário"
        // onChange={handleOnChange}
        />
        <Input
          label="E-mail"
          formValue="txEmail"
          // value={searchParams.txEmail}
          control={control}
          placeholder="E-mail"
        // onChange={handleOnChange}
        />
        <SelectForm
          label="Status"
          formValue="flLiberado"
          // defaultValue={null}
          // value={String(searchParams.flLiberado)}
          // onChange={handleOnChange}
          control={control}
          // defaultPlaceholderValue={null}
          // clearSelect
          defaultValue={String(watch('flLiberado'))}
          listOptions={[
            { label: 'Respondido', value: 'true' },
            { label: 'Não Respondido', value: 'false' }
          ]}
        />
      </Grid>
      <Row justifyContent="flex-end" marginTop={SPACING.spacing10}>
        <Button text="Limpar" variantButton="text" onClick={handleOnClear} />
        <Button
          text="Pesquisar"
          endIcon={<MagnifyingGlassIcon />}
          disabled={!areDatesValid()}
          type={'submit'}
          // onClick={handleOnSearch}
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing10}
        />
      </Row>
    </Form>
  )
}

export default FilterTalkToUs
